import { Chip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ChipClock, ChipsList } from '@/components/Hypertracker/HyperSearch/HyperSearchStyled';
import React from 'react';
import { useNavigate } from 'react-router';
import { shortenString } from '@/lib/helpers/helpers';

const LastSearchList = ({ lastSearch, onSaveSearchClick }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const navigate = useNavigate();

    const getLabel = (chipItem) => {
        if (chipItem.type !== 'wallet' && chipItem.type !== 'builder') {
            return chipItem.label;
        }
        return shortenString(chipItem.label);
    };

    const onClick = (searchItem) => {
        const url = searchItem.url;
        const result = url.split('/hypertracker/')?.[1] || '';
        onSaveSearchClick(searchItem);
        setTimeout(() => {
            navigate(`/hypertracker/${result}`);
        }, 200);
    };

    if (!lastSearch) return null;
    return (
        <ChipsList sx={{}}>
            {lastSearch.map((item: any) => {
                return (
                    <Chip
                        tabIndex={-1}
                        onClick={() => onClick(item)}
                        sx={{
                            borderRadius: '4px',
                            padding: isMobile ? '12px' : '2px',
                            margin: 0,
                            height: 'unset',
                            cursor: 'pointer',
                        }}
                        key={item.label}
                        label={
                            <Typography
                                component={'p'}
                                color={'common.white'}
                                variant={isMobile ? 'p12' : 'p10'}
                                sx={{ padding: 0 }}
                            >
                                {getLabel(item)}
                            </Typography>
                        }
                        icon={isMobile ? <div /> : <ChipClock />}
                    />
                );
            })}
        </ChipsList>
    );
};

export default LastSearchList;
